import React, { useState, useEffect, useRef } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import logo from "../../Assets/logo-white.webp";

export default function NavBar() {
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const collapseRef = useRef(null);
  const toggleRef   = useRef(null);

  // handle scroll shadow/blur
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const onEscape = (event) => {
      if (event.key === "Escape" && expanded) {
        setExpanded(false);
        toggleRef.current?.focus();
      }
    };

    document.addEventListener("keydown", onEscape);
    return () => document.removeEventListener("keydown", onEscape);
  }, [expanded]);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 768) {
        setExpanded(false);
      }
    };

    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // close menu when clicking outside
  useEffect(() => {
    const onClickOutside = (e) => {
      if (
               expanded &&
               collapseRef.current &&
               !collapseRef.current.contains(e.target) &&
               toggleRef.current &&
               !toggleRef.current.contains(e.target)
             ) {
                setExpanded(false);
              }
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, [expanded]);

  const links = [
    { to: "/", label: "Home", end: true },
    { to: "/about", label: "About" },
    { to: "/products", label: "Products" },
    { to: "/solution", label: "Solution" },
    { to: "/production", label: "Production" },
    { to: "/blog", label: "Blogs" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <Navbar
      expanded={expanded}
      onToggle={setExpanded}
      fixed="top"
      expand="md"
      variant="dark"
      className={scrolled ? "sticky" : "navbar"}
    >
      <Container>
        <Navbar.Brand as={NavLink} to="/" end aria-label="Klean Leaf home">
          <img
            src={logo}
            alt="Klean Leaf logo"
            className="img-fluid logo"
          />
        </Navbar.Brand>

        <Navbar.Toggle
          ref={toggleRef}
          aria-controls="responsive-navbar-nav"
          aria-expanded={expanded}
          className="navbar-toggler"
          onClick={() => setExpanded((prev) => !prev)}
        >
          <span />
          <span />
          <span />
        </Navbar.Toggle>

        <Navbar.Collapse
          id="responsive-navbar-nav"
          ref={collapseRef}
        >
          <Nav className="ms-auto">
            {links.map(({ to, label, end }) => (
              <Nav.Item key={to}>
                <Nav.Link
                  as={NavLink}
                  to={to}
                  end={end}
                  className="nav-link"
                  onClick={() => setExpanded(false)}
                >
                  {label}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
